interface PasswordOptions {
  length: number;
  uppercase: boolean;
  lowercase: boolean;
  numbers: boolean;
  symbols: boolean;
}

const CHARS = {
  uppercase: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
  lowercase: 'abcdefghijklmnopqrstuvwxyz',
  numbers: '0123456789',
  symbols: '!@#$%^&*()_+-=[]{}|;:,.<>?',
};

export function generatePassword(options: PasswordOptions): string {
  let charset = '';

  if (options.uppercase) charset += CHARS.uppercase;
  if (options.lowercase) charset += CHARS.lowercase;
  if (options.numbers) charset += CHARS.numbers;
  if (options.symbols) charset += CHARS.symbols;

  if (charset.length === 0) {
    charset = CHARS.lowercase + CHARS.numbers;
  }

  const array = new Uint32Array(options.length);
  crypto.getRandomValues(array);

  let password = '';
  for (let i = 0; i < options.length; i++) {
    password += charset[array[i] % charset.length];
  }

  // Ensure at least one character from each selected category
  const required: string[] = [];
  if (options.uppercase) required.push(randomChar(CHARS.uppercase));
  if (options.lowercase) required.push(randomChar(CHARS.lowercase));
  if (options.numbers) required.push(randomChar(CHARS.numbers));
  if (options.symbols) required.push(randomChar(CHARS.symbols));

  // Replace random positions with required characters
  const positions = new Set<number>();
  const posArray = new Uint32Array(required.length);
  crypto.getRandomValues(posArray);

  for (let i = 0; i < required.length; i++) {
    let pos = posArray[i] % options.length;
    while (positions.has(pos)) {
      pos = (pos + 1) % options.length;
    }
    positions.add(pos);
    password =
      password.substring(0, pos) + required[i] + password.substring(pos + 1);
  }

  return password;
}

function randomChar(charset: string): string {
  const array = new Uint32Array(1);
  crypto.getRandomValues(array);
  return charset[array[0] % charset.length];
}
